import ROUTES from 'CONSTANTS/routes';
import MainPage from '../features/Home';

const recorderRoutes = [{ path: `${ROUTES.RECORDER}/:meetingId`, element: <MainPage /> }];

export default recorderRoutes;
